export class DocType {
  static GENERIC_FILE = "file";
  static FACTURE = "facture";
  static JUSTIFICATIF_BALANCE = "justificatif_balance";
  static LOGO = "logo";
  static SIGNATURE = "signature";
  static QUITTANCE = "quittance";
  static LIASSE = "liasse";
  static TABLEAU_AMORTISSEMENT = "tableau_amortissement";
  static TABLEAU_IMMOBILISATION = "tableau_immobilisation";
  static PROPERTY_PHOTO = "property_photo";
}

export class FileTag {
  static BAIL = "bail";
  static EDL = "edl";
  static ASSURANCE_HABITATION = "assurance_habitation";
  static ENTRETIEN_CHAUFFAGE = "entretien_chauffage";
  static CAUTION = "caution";
  static DPE = "DPE";
  static MESURAGE = "mesurage";
  static ELEC = "elec";
  static POLLUTION = "pollution";
  static PLOMB = "plomb";
  static AMIANTE = "amiante";
  static GAZ = "gaz";
  static TERMITE = "termite";
  static RISQUE_NATUREL = "risque_naturel";
  static BRUIT = "bruit";
  static ANNEXE_ENVIRONNEMENTALE = "annexe_environnementale";
}

/**
 * Diagnostics exigibles pour louer (dossier de diagnostic technique, bail commercial),
 * dans l'ordre d'affichage du pilotage. Chaque bien n'est concerné que par une partie
 * d'entre eux : voir `utils/diagnosticRules.ts`.
 */
export const DIAGNOSTIC_TAGS = [
  FileTag.DPE,
  FileTag.PLOMB,
  FileTag.AMIANTE,
  FileTag.ELEC,
  FileTag.GAZ,
  FileTag.RISQUE_NATUREL,
  FileTag.BRUIT,
  FileTag.ANNEXE_ENVIRONNEMENTALE,
];

/** Diagnostics facultatifs en location (exigés à la vente seulement), conservés comme documents du bien. */
export const OPTIONAL_DIAGNOSTIC_TAGS = [FileTag.MESURAGE, FileTag.TERMITE];

/** Tags qui valent pour un autre diagnostic : `pollution` est l'ancien tag de l'état des risques et pollutions. */
export const DIAGNOSTIC_TAG_ALIASES = {
  [FileTag.RISQUE_NATUREL]: [FileTag.POLLUTION],
};

/** Tous les tags de diagnostic, pour reconnaître un document de diagnostic. */
export const ALL_DIAGNOSTIC_TAGS = [
  ...DIAGNOSTIC_TAGS,
  ...OPTIONAL_DIAGNOSTIC_TAGS,
];

/** Diagnostics qu'un même PDF de diagnostiqueur peut regrouper (l'annexe environnementale est un document à part). */
export const GROUPABLE_DIAGNOSTIC_TAGS = ALL_DIAGNOSTIC_TAGS.filter(
  (tag) => tag !== FileTag.ANNEXE_ENVIRONNEMENTALE,
);

/** Clé de `file.meta` listant les autres diagnostics regroupés dans un même PDF. */
export const META_DIAGNOSTICS = "diagnostics";

// Limites et types autorisés pour l'upload de fichiers
export const MAX_FILE_SIZE = 50 * 1024 * 1024; // 50 Mo

/** Photos iPhone : la plupart des navigateurs ne les décodent pas, le serveur les convertit en JPEG. */
export const HEIC_MIME_TYPES = ["image/heic", "image/heif"];

export const ALLOWED_MIME_TYPES = [
  "image/png",
  "image/jpeg",
  "image/jpg",
  ...HEIC_MIME_TYPES,
  "application/pdf",
];

export const ACCEPTED_FILE_EXTENSIONS = ".png,.jpg,.jpeg,.heic,.heif,.pdf";
export const ACCEPTED_IMAGE_EXTENSIONS = ".png,.jpg,.jpeg,.heic,.heif";
